import type { SVGProps } from 'react'

interface DensitySatelliteIconProps extends SVGProps<SVGSVGElement> {}

export function DensitySatelliteIcon(props: DensitySatelliteIconProps) {
  return (
    <svg
      width={79}
      height={59}
      viewBox="0 0 79 59"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.444 32.739l-.145.283-1.719-.994v-.186l.124-.056 1.74.953zM7.568 32.87l.124.152 4.522-2.61v-.186l-.228-.006-4.494 2.526.076.124z"
        fill="currentColor"
      />
      <path
        d="M7.299 33.022v-.187l.214-.151.18.151v.187h-.394z"
        fill="currentColor"
      />
      <path
        d="M12.213 29.998v.228l-4.52 2.61h-.394l-1.719-.994v-.221l4.521-2.61h.394l1.719.988zM9.673 34.03l-.145.276-1.712-.987v-.187l.118-.055 1.74.953zM9.798 34.16l.124.146 4.521-2.61v-.179l-.22-.007-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M9.528 34.306v-.18l.221-.151.173.151v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M14.443 31.29v.227l-4.521 2.61h-.394l-1.712-.995v-.227l4.515-2.61h.393l1.719.994zM2.467 35.61l-.145.284L.61 34.9v-.187l.118-.055 1.74.953zM2.592 35.742l.124.151 4.521-2.616v-.18h-.22l-4.501 2.52.076.125z"
        fill="currentColor"
      />
      <path
        d="M2.322 35.893v-.186l.221-.152.173.152v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M7.237 32.87v.228l-4.521 2.61h-.394L.61 34.712v-.22l4.515-2.61h.393l1.719.987zM4.697 36.901l-.138.276-1.72-.987v-.186l.125-.055 1.733.952zM4.828 37.032l.124.145 4.521-2.609v-.18l-.227-.006L4.752 36.9l.076.131z"
        fill="currentColor"
      />
      <path
        d="M4.559 37.177v-.18l.214-.151.179.152v.18h-.393z"
        fill="currentColor"
      />
      <path
        d="M9.473 34.16v.229l-4.521 2.609h-.393l-1.72-.994v-.228l4.522-2.61h.393l1.72.995zM11.904 35.314l-.138.283-1.72-.994v-.18l.118-.062 1.74.953zM12.035 35.452l.124.145 4.521-2.61v-.18l-.227-.006-4.5 2.52.082.13z"
        fill="currentColor"
      />
      <path
        d="M11.766 35.596v-.179l.214-.152.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M16.68 32.58v.228l-4.52 2.61h-.394l-1.72-.995v-.228l4.522-2.609h.393l1.72.994zM6.933 38.185l-.145.283-1.719-.994v-.18l.125-.061 1.739.952zM7.057 38.323l.125.145 4.52-2.609v-.18l-.227-.006-4.494 2.519.076.131z"
        fill="currentColor"
      />
      <path
        d="M6.788 38.468v-.18l.221-.151.173.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M11.703 35.452v.227l-4.521 2.61h-.394l-1.719-.994v-.228l4.522-2.61h.393l1.719.995zM14.14 36.604l-.146.283-1.719-.994v-.179l.125-.062 1.74.952zM14.263 36.742l.125.145 4.52-2.609v-.186h-.22l-4.5 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M13.994 36.887v-.186l.221-.152.173.152v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M18.909 33.864v.228L14.388 36.7h-.394l-1.719-.987v-.228l4.522-2.609h.393l1.719.987zM16.369 37.895l-.139.283-1.718-.994v-.186l.117-.055 1.74.952zM16.493 38.026l.131.152 4.521-2.616v-.18l-.227-.006-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M16.23 38.178v-.186l.214-.152.18.152v.186h-.393z"
        fill="currentColor"
      />
      <path
        d="M21.145 35.155v.228l-4.521 2.609h-.393l-1.72-.994v-.228l4.522-2.602h.393l1.72.987zM18.606 39.186l-.145.276-1.719-.987v-.187l.124-.062 1.74.96zM18.73 39.317l.125.145 4.52-2.61v-.179l-.227-.007-4.494 2.52.076.131z"
        fill="currentColor"
      />
      <path
        d="M18.46 39.462v-.18l.222-.151.172.152v.18h-.393z"
        fill="currentColor"
      />
      <path
        d="M23.376 36.446v.227l-4.522 2.61h-.393l-1.719-.994v-.228l4.521-2.61h.394l1.719.995zM20.835 40.47l-.138.283-1.718-.994v-.18l.117-.062 1.74.953zM20.96 40.608l.13.145 4.515-2.61v-.186h-.22l-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M20.697 40.753v-.187l.214-.145.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M25.605 37.736v.221l-4.514 2.616-.394-.007-1.718-.987v-.227l4.52-2.61h.394l1.712.994zM9.163 39.476l-.138.283-1.718-.994v-.18l.117-.062 1.74.953zM9.288 39.614l.131.145 4.521-2.61v-.186h-.228l-4.5 2.52.076.131z"
        fill="currentColor"
      />
      <path
        d="M9.025 39.759v-.187l.214-.151.18.151v.187h-.394z"
        fill="currentColor"
      />
      <path
        d="M13.94 36.736v.227l-4.521 2.61h-.394l-1.718-.987v-.228l4.52-2.61h.394l1.719.988zM11.399 40.767l-.145.282-1.719-.993v-.187l.124-.055 1.74.953zM11.523 40.898l.124.152 4.522-2.61v-.186h-.228l-4.494 2.52.076.124z"
        fill="currentColor"
      />
      <path
        d="M11.254 41.05v-.187l.214-.152.18.152v.187h-.394z"
        fill="currentColor"
      />
      <path
        d="M16.169 38.026v.228l-4.522 2.61h-.393l-1.719-.995v-.22l4.521-2.61.394-.007 1.719.994zM13.63 42.057l-.139.276-1.718-.987v-.186l.117-.055 1.74.952zM13.754 42.188l.13.145 4.515-2.609v-.18l-.22-.006-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M13.491 42.334v-.18l.214-.152.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M18.399 39.317v.228l-4.514 2.609h-.394l-1.718-.994v-.228l4.52-2.609h.394l1.712.994zM15.866 43.342l-.145.282-1.719-.994v-.179l.124-.062 1.74.953zM15.99 43.48l.124.144 4.521-2.609v-.186h-.227l-4.494 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M15.72 43.624v-.186l.215-.145.18.145v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M20.635 40.608v.22l-4.52 2.61h-.394l-1.719-.987v-.228l4.521-2.609h.394l1.718.994z"
        fill="currentColor"
      />
      <path
        d="M25.37 38.282v-.186l.372.662.235.228v.18l-3.88 2.236.546.193v.186l-.235.132-.6-.339-3.928 2.264-1.767-.214v-.186l.318-.055 1.373.193 7.856-4.5-.29-.794z"
        fill="currentColor"
      />
      <path
        d="M25.37 38.095l.234-.138.373 1.029-3.934 2.27.6.339-.235.138-.6-.345-3.928 2.27-1.767-.22.235-.131 1.38.165 7.932-4.576-.29-.8zM55.355 22.634l1.774-1.498-1.36.124-2.022 1.166.38.311 1.228-.103zM58.026 29.833l2.023-1.166.78-1.112-2.188.904-.615 1.374z"
        fill="currentColor"
      />
      <path
        d="M59.235 26.527l1.595-.78v1.808l-2.023 1.167-.145-1.885.573-.31z"
        fill="currentColor"
      />
      <path
        d="M59.71 23.724l.339.007.78 2.016-2.022 1.166-.905-2.015 1.809-1.174z"
        fill="currentColor"
      />
      <path
        d="M56.797 22.91l1.892-.87 1.36 1.691-2.023 1.167-1.574-1.684.345-.304z"
        fill="currentColor"
      />
      <path
        d="M55.106 22.31l2.023-1.174 1.56.904-2.023 1.173-1.221-.11-.339-.794z"
        fill="currentColor"
      />
      <path
        d="M58.026 24.898l-1.36-1.685-1.56-.904-1.36.117-.78 1.112v1.808l.78 2.016 1.36 1.69 1.56.905 1.36-.124.78-1.111v-1.809l-.78-2.015zM36.18 34.561l.352-.02v2.243l-.173.103-.131-.082-.048-2.244zM36.242 34.361l.069-.2-5.108-2.955-.18.104.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M36.532 34.54l-.173.104-.27-.124.042-.263.18-.096.22.38z"
        fill="currentColor"
      />
      <path
        d="M30.803 31.441l.22-.13 5.109 2.947.227.386v2.243l-.227.125-5.108-2.948-.221-.386V31.44zM36.18 31.648l.352-.02v2.243l-.173.104-.131-.083-.048-2.244zM36.242 31.448l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M36.532 31.628l-.173.103-.27-.124.042-.262.18-.104.22.387z"
        fill="currentColor"
      />
      <path
        d="M30.803 28.521l.22-.124 5.109 2.948.227.386v2.243l-.227.125-5.108-2.948-.221-.386V28.52zM36.18 28.729l.352-.014v2.236l-.173.104-.131-.083-.048-2.243zM36.242 28.535l.069-.207-5.108-2.954-.18.104.125.22 5.011 2.982.083-.145z"
        fill="currentColor"
      />
      <path
        d="M36.532 28.715l-.173.104-.27-.132.042-.255.18-.104.22.387z"
        fill="currentColor"
      />
      <path
        d="M30.803 25.609l.22-.132 5.109 2.955.227.386v2.237l-.227.131-5.108-2.947-.221-.387v-2.243zM36.18 25.816l.352-.021v2.243l-.173.104-.131-.083-.048-2.243zM36.242 25.615l.069-.2-5.108-2.954-.18.104.125.22 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M36.532 25.795l-.173.103-.27-.124.042-.262.18-.097.22.38z"
        fill="currentColor"
      />
      <path
        d="M30.803 22.696l.22-.132 5.109 2.948.227.386v2.244l-.227.13-5.108-2.953-.221-.387v-2.236zM36.18 22.903l.352-.02v2.242l-.173.104-.131-.083-.048-2.243zM36.242 22.703l.069-.207-5.108-2.948-.18.104.125.22 5.011 2.982.083-.151z"
        fill="currentColor"
      />
      <path
        d="M36.532 22.882l-.173.104-.27-.125.042-.262.18-.103.22.386z"
        fill="currentColor"
      />
      <path
        d="M30.803 19.776l.22-.124 5.109 2.947.227.387v2.243l-.227.124-5.108-2.947-.221-.387v-2.243zM32.15 20.093l-.173.104.434-.732.083-.359.18-.103.89.51-.117-.641.18-.104.262.159v.773l.952.552.787 1.85-.172.104-.235-.276-.594-1.457-1.857-1.111-.62.731z"
        fill="currentColor"
      />
      <path
        d="M31.976 20.197l-.269-.152.787-.939.953.546v-.78l.269.151v.78l.945.553.794 1.85-.27-.152-.613-1.45-1.981-1.139-.615.732zM49.171 26.74l-1.746 1.009-.09-.822 1.836-.966v.78z"
        fill="currentColor"
      />
      <path
        d="M47.425 26.968l1.746-1.007-22.723-13.122-1.747 1.008 22.724 13.121zM47.425 27.748L24.7 14.627v-.78l22.724 13.121v.78z"
        fill="currentColor"
      />
      <path
        d="M35.365 16.822l.263.152-.787.945-.18.097-.055-.235-.718-.414v.78l-.172.104-.187-.318v-.773l-1.014-.587-.573-1.325-.235-.332.18-.103.262.152.621 1.45 1.981 1.138.614-.731z"
        fill="currentColor"
      />
      <path
        d="M35.186 16.925l.27.152-.795.939-.945-.545v.78l-.27-.16v-.772l-.952-.553-.787-1.85.27.152.614 1.443 1.98 1.146.615-.732zM36.18 15.013l.352-.014.007 2.244-.18.096-.131-.083-.048-2.243zM36.242 14.82l.069-.207-5.108-2.948-.18.097.125.228 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M36.532 15l-.173.103-.27-.131.042-.256.18-.103.22.386z"
        fill="currentColor"
      />
      <path
        d="M30.803 11.893l.22-.131 5.109 2.954.227.387v2.236l-.227.131-5.108-2.954-.221-.38v-2.243zM36.18 12.1l.352-.02v2.243l-.173.104-.131-.083-.048-2.244zM36.242 11.907l.069-.207-5.108-2.954-.18.103.125.221 5.011 2.982.083-.145z"
        fill="currentColor"
      />
      <path
        d="M36.532 12.08l-.173.103-.27-.124.042-.255.18-.104.22.38z"
        fill="currentColor"
      />
      <path
        d="M30.803 8.98l.22-.13 5.109 2.953.227.38v2.243l-.227.132-5.108-2.955-.221-.386V8.98zM36.18 9.187l.352-.02v2.243l-.173.104-.131-.083-.048-2.244zM36.242 8.987l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M36.532 9.167l-.173.103-.27-.124.042-.262.18-.104.22.387z"
        fill="currentColor"
      />
      <path
        d="M30.803 6.067l.22-.13 5.109 2.947.227.386v2.244l-.227.124-5.108-2.948-.221-.386V6.067zM36.18 6.274l.352-.02v2.243l-.173.104-.131-.09-.048-2.237zM36.242 6.074l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M36.532 6.253l-.173.104-.27-.131.042-.256.18-.103.22.386z"
        fill="currentColor"
      />
      <path
        d="M30.803 3.147l.22-.124 5.109 2.948.227.386V8.6l-.227.125-5.108-2.948-.221-.386V3.147zM36.18 3.355l.352-.014v2.236l-.173.104-.131-.083-.048-2.243zM36.242 3.161l.069-.207L31.203 0l-.18.104.125.22 5.011 2.982.083-.145z"
        fill="currentColor"
      />
      <path
        d="M36.532 3.34l-.173.104-.27-.13.042-.256.18-.104.22.387z"
        fill="currentColor"
      />
      <path
        d="M30.803.235l.22-.131 5.109 2.954.227.386v2.237l-.227.131-5.108-2.954-.221-.38V.235zM49.494 30.93l.083 2.975.71.663 8.767-5.06v-3.05l-9.56 4.472z"
        fill="currentColor"
      />
      <path
        d="M48.908 27.327l8.283-4.107 1.863 3.238-8.766 5.06-2.54-3.231 1.16-.96z"
        fill="currentColor"
      />
      <path
        d="M51.955 27.098l-2.271 1.311.483.837 2.271-1.311-.483-.837zM51.87 28.954l-1.4.807.296.514 1.4-.806-.297-.515zM54.547 21.702l-8.766 5.06.421 1.483 2.223.042 8.766-5.067-2.644-1.518z"
        fill="currentColor"
      />
      <path
        d="M48.424 28.287l-2.643-1.526-1.864 1.077v3.044l1.864 3.237 2.643 1.526 1.864-1.077v-3.05l-1.864-3.231zM71.72 54.986l.36-.02v2.243l-.18.103-.131-.083-.048-2.243zM71.783 54.786l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M72.08 54.965l-.18.104-.27-.124.05-.263.172-.103.227.386z"
        fill="currentColor"
      />
      <path
        d="M66.344 51.86l.22-.125 5.115 2.947.221.387v2.243l-.228.125-5.107-2.948-.221-.386v-2.244zM71.72 52.066l.36-.014v2.237l-.18.103-.131-.082-.048-2.244zM71.783 51.873l.069-.207-5.108-2.954-.18.103.125.228 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M72.08 52.053l-.18.096-.27-.124.05-.255.172-.104.227.387z"
        fill="currentColor"
      />
      <path
        d="M66.344 48.946l.22-.13 5.115 2.953.221.38v2.243l-.228.132-5.107-2.955-.221-.38v-2.243zM71.72 49.153l.36-.02v2.243l-.18.103-.131-.082-.048-2.244zM71.783 48.953l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M72.08 49.133l-.18.103-.27-.124.05-.262.172-.104.227.387z"
        fill="currentColor"
      />
      <path
        d="M66.344 46.033l.22-.13 5.115 2.947.221.386v2.244l-.228.13-5.107-2.953-.221-.387v-2.237zM71.72 46.24l.36-.02v2.243l-.18.104-.131-.083-.048-2.243zM71.783 46.04l.069-.207-5.108-2.947-.18.103.125.221 5.011 2.982.083-.151z"
        fill="currentColor"
      />
      <path
        d="M72.08 46.22l-.18.104-.27-.125.042-.262.18-.103.227.386z"
        fill="currentColor"
      />
      <path
        d="M66.344 43.114l.22-.124 5.109 2.947.227.387v2.243l-.228.124-5.107-2.947-.221-.387v-2.243zM71.72 43.32l.36-.013v2.237l-.18.103-.131-.083-.048-2.243zM71.783 43.128l.069-.207-5.108-2.955-.18.104.125.228 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M72.08 43.307l-.18.104-.27-.131.042-.256.18-.103.227.386z"
        fill="currentColor"
      />
      <path
        d="M66.344 40.201l.22-.131 5.109 2.954.227.387v2.236l-.228.131-5.107-2.947-.221-.387v-2.243z"
        fill="currentColor"
      />
      <path
        d="M67.697 40.518l-.18.104.435-.732.09-.366.18-.103.883.518-.117-.642.18-.104.268.152v.78l.946.545.794 1.857-.18.104-.234-.276-.594-1.457-1.857-1.118-.614.738z"
        fill="currentColor"
      />
      <path
        d="M67.517 40.622l-.269-.159.794-.939.945.546v-.773l.27.152v.78l.945.545.794 1.857-.269-.16-.614-1.442-1.981-1.146-.615.739zM78.272 43.541l-1.747 1.008-.09-.821 1.837-.967v.78z"
        fill="currentColor"
      />
      <path
        d="M76.525 43.77l1.746-1.009-22.73-13.121-1.74 1.007L76.526 43.77z"
        fill="currentColor"
      />
      <path
        d="M76.525 44.55L53.802 31.427v-.78l22.723 13.121v.78zM70.906 37.24l.27.158-.794.94-.18.103-.055-.242-.71-.407v.773l-.18.103-.187-.31v-.78l-1.014-.587-.566-1.318-.242-.339.18-.103.269.159.614 1.442 1.981 1.146.614-.738z"
        fill="currentColor"
      />
      <path
        d="M70.727 37.343l.27.159-.795.939-.945-.546v.773l-.27-.151v-.78l-.945-.546-.794-1.857.27.16.614 1.442 1.98 1.146.615-.739zM71.72 35.438l.36-.02v2.243l-.18.103-.131-.083-.048-2.243zM71.783 35.238l.069-.2-5.108-2.955-.18.104.125.22L71.7 35.39l.083-.152z"
        fill="currentColor"
      />
      <path
        d="M72.08 35.417l-.18.104-.27-.124.042-.256.18-.103.227.38z"
        fill="currentColor"
      />
      <path
        d="M66.344 32.318l.22-.131 5.109 2.954.227.38v2.243l-.22.131-5.115-2.954-.221-.386v-2.237zM71.72 32.525l.36-.02v2.243l-.18.103-.131-.083-.048-2.243zM71.783 32.325l.069-.207-5.108-2.948-.18.104.125.22 5.011 2.983.083-.152z"
        fill="currentColor"
      />
      <path
        d="M72.08 32.505l-.18.103-.27-.124.042-.263.18-.103.227.386z"
        fill="currentColor"
      />
      <path
        d="M66.344 29.398l.22-.124 5.109 2.947.227.387v2.243l-.228.131-5.107-2.954-.221-.386v-2.244zM71.72 29.612l.36-.02v2.243l-.18.096-.131-.082-.048-2.237zM71.783 29.412l.069-.207-5.108-2.947-.18.096.125.228 5.011 2.975.083-.145z"
        fill="currentColor"
      />
      <path
        d="M72.08 29.592l-.18.103-.27-.131.05-.255.172-.104.227.387z"
        fill="currentColor"
      />
      <path
        d="M66.344 26.485l.22-.13 5.115 2.954.221.386v2.236l-.228.132-5.107-2.948-.221-.386v-2.244zM71.72 26.693l.36-.021v2.243l-.18.104-.131-.083-.048-2.243zM71.783 26.492l.069-.2-5.108-2.954-.18.103.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M72.08 26.672l-.18.103-.27-.124.042-.255.18-.104.227.38z"
        fill="currentColor"
      />
      <path
        d="M66.344 23.573l.22-.132 5.109 2.955.227.38v2.243l-.22.13-5.115-2.954-.221-.38v-2.242zM71.72 23.78l.36-.021v2.243l-.18.104-.131-.083-.048-2.244zM71.783 23.58l.069-.2-5.108-2.955-.18.103.125.221 5.011 2.982.083-.152z"
        fill="currentColor"
      />
      <path
        d="M72.08 23.759l-.18.103-.27-.124.042-.262.18-.097.227.38z"
        fill="currentColor"
      />
      <path
        d="M66.344 20.653l.22-.125 5.109 2.948.227.386v2.244l-.228.124-5.107-2.948-.221-.386v-2.243zM42.454 38.075l.028.89.214.2 2.416-1.394v-.911l-2.658 1.215z"
        fill="currentColor"
      />
      <path
        d="M42.282 36.998l2.27-1.105.56.967-2.416 1.394-.76-.966.346-.29z"
        fill="currentColor"
      />
      <path
        d="M43.764 35.438l-2.415 1.394.124.442.663.014 2.415-1.395-.787-.455z"
        fill="currentColor"
      />
      <path
        d="M42.136 37.288l-.787-.456-.559.318v.91l.56.974.786.456.56-.325v-.911l-.56-.966zM39.112 32.277l.028.89.207.2 2.416-1.394v-.911l-2.65 1.215z"
        fill="currentColor"
      />
      <path
        d="M38.94 31.2l2.27-1.105.553.967-2.416 1.394-.76-.967.353-.29z"
        fill="currentColor"
      />
      <path
        d="M40.417 29.64L38 31.034l.124.442.67.014 2.416-1.395-.794-.455z"
        fill="currentColor"
      />
      <path
        d="M38.795 31.49l-.794-.456-.559.318v.91l.56.974.793.449.552-.318v-.911l-.552-.967zM40.093 35.583l.027.89.214.2 2.416-1.394v-.911l-2.657 1.215z"
        fill="currentColor"
      />
      <path
        d="M39.92 34.506l2.271-1.105.56.967-2.416 1.394-.767-.966.352-.29z"
        fill="currentColor"
      />
      <path
        d="M41.397 32.939l-2.416 1.401.132.442.662.014 2.416-1.395-.794-.462z"
        fill="currentColor"
      />
      <path
        d="M39.776 34.796l-.794-.456-.552.318v.911l.552.966.794.456.559-.318v-.91l-.56-.967zM40.093 30.109l.027.89.214.194 2.416-1.395v-.91l-2.657 1.221z"
        fill="currentColor"
      />
      <path
        d="M39.92 29.032l2.271-1.111.56.966-2.416 1.395-.767-.967.352-.283z"
        fill="currentColor"
      />
      <path
        d="M41.397 27.465l-2.416 1.395.132.448.662.007 2.416-1.394-.794-.456z"
        fill="currentColor"
      />
      <path
        d="M39.776 29.315l-.794-.455-.56.324v.911l.56.966.794.456.559-.324v-.911l-.56-.967zM44.828 38.316l.028.89.207.194 2.416-1.394v-.912l-2.65 1.222z"
        fill="currentColor"
      />
      <path
        d="M44.648 37.24l2.27-1.112.56.966-2.416 1.395-.76-.966.346-.284z"
        fill="currentColor"
      />
      <path
        d="M46.133 35.673l-2.416 1.394.124.442.663.014 2.416-1.395-.787-.455z"
        fill="currentColor"
      />
      <path
        d="M44.503 37.523l-.787-.456-.559.324v.912l.56.966.786.455.56-.324v-.911l-.56-.966z"
        fill="currentColor"
      />
      <path
        d="M42.308 34.803l.069 2.236.531.497 6.592-3.803V31.44l-7.192 3.362z"
        fill="currentColor"
      />
      <path
        d="M41.874 32.09l6.219-3.079 1.408 2.43-6.592 3.804-1.912-2.43.877-.725z"
        fill="currentColor"
      />
      <path
        d="M46.111 27.866l-6.591 3.803.317 1.111 1.67.035 6.586-3.803-1.982-1.146z"
        fill="currentColor"
      />
      <path
        d="M41.507 32.815l-1.988-1.146-1.4.808v2.292l1.4 2.43 1.988 1.145 1.402-.808v-2.291l-1.402-2.43zM44.822 32.836l.028.89.214.2 2.416-1.4v-.912l-2.658 1.222z"
        fill="currentColor"
      />
      <path
        d="M44.649 31.759l2.27-1.111.56.966-2.416 1.401-.76-.973.346-.283z"
        fill="currentColor"
      />
      <path
        d="M46.134 30.192l-2.416 1.394.124.449.663.007 2.416-1.395-.787-.455z"
        fill="currentColor"
      />
      <path
        d="M44.504 32.042l-.787-.456-.559.325v.91l.56.967.786.456.56-.318v-.911l-.56-.973zM45.808 36.142l.027.89.214.194 2.416-1.394v-.912l-2.657 1.222z"
        fill="currentColor"
      />
      <path
        d="M45.635 35.065l2.271-1.111.56.966-2.417 1.395-.766-.967.352-.283z"
        fill="currentColor"
      />
      <path
        d="M47.112 33.498l-2.416 1.395.125.448.67.007 2.415-1.394-.794-.456z"
        fill="currentColor"
      />
      <path
        d="M45.49 35.348l-.793-.455-.56.324v.911l.56.967.794.455.559-.324v-.911l-.56-.967zM42.454 30.344l.028.89.214.2 2.416-1.394v-.911l-2.658 1.215z"
        fill="currentColor"
      />
      <path
        d="M42.282 29.274l2.27-1.111.56.966-2.416 1.394-.76-.966.346-.283z"
        fill="currentColor"
      />
      <path
        d="M43.764 27.707l-2.415 1.394.124.442.663.014 2.415-1.394-.787-.456z"
        fill="currentColor"
      />
      <path
        d="M42.136 29.557l-.787-.456-.559.325v.91l.56.967.786.456.56-.325v-.91l-.56-.967zM29.837 37.364l9.898-6.185-1.36.124-10.146 5.86.38.311 1.228-.11zM32.508 44.57l10.147-5.86.78-1.118-10.32 5.605-.607 1.373z"
        fill="currentColor"
      />
      <path
        d="M33.715 41.257l9.72-5.467v1.801l-10.148 5.86-.144-1.884.572-.31z"
        fill="currentColor"
      />
      <path
        d="M42.324 33.767l.33.007.78 2.016-10.146 5.86-.911-2.015 9.947-5.868z"
        fill="currentColor"
      />
      <path
        d="M31.28 37.647l10.015-5.564 1.36 1.691-10.147 5.86-1.573-1.69.345-.297z"
        fill="currentColor"
      />
      <path
        d="M29.581 37.04l10.154-5.861 1.56.904-10.147 5.86-1.222-.11-.345-.794z"
        fill="currentColor"
      />
      <path
        d="M32.508 39.634l-1.36-1.69-1.567-.905-1.353.124-.78 1.112v1.808l.78 2.016 1.353 1.684 1.567.904 1.36-.117.78-1.118V41.65l-.78-2.016z"
        fill="currentColor"
      />
      <path
        d="M23.99 45.654l.082 2.975.711.662 8.766-5.06v-3.05l-9.56 4.473z"
        fill="currentColor"
      />
      <path
        d="M23.403 42.05l8.283-4.106 1.864 3.237-8.767 5.06-2.54-3.23 1.16-.96z"
        fill="currentColor"
      />
      <path
        d="M26.454 41.826l-2.271 1.312.483.836 2.271-1.311-.483-.837zM26.363 43.68l-1.4.806.297.514 1.4-.806-.297-.515zM29.042 36.425l-8.767 5.06.421 1.484 2.223.041 8.766-5.066-2.643-1.519z"
        fill="currentColor"
      />
      <path
        d="M20.276 41.485l-1.864 1.076-2.105 3.818 1.67-.615 2.299-4.28zM22.92 50.368l-4.363-.083.62-.994 3.915-.414 1.69.414-1.863 1.077z"
        fill="currentColor"
      />
      <path
        d="M19.496 49.747l5.288-.456v-3.05l-3.638.973-1.65 1.008v1.525z"
        fill="currentColor"
      />
      <path
        d="M24.783 46.24l-5.287 1.982-.939-.925-.366-1.098 4.729-3.189 1.863 3.23z"
        fill="currentColor"
      />
      <path
        d="M20.275 41.485l-3.037 4.355.504.642.815.117 4.362-3.589-2.644-1.525zM18.475 48.284l.048 1.484.352.33.621-.351V48.22l-1.021.063z"
        fill="currentColor"
      />
      <path
        d="M18.184 46.482l.373.117.939 1.622-.621.352-1.27-1.615.58-.476z"
        fill="currentColor"
      />
      <path
        d="M17.238 45.84l-.62.359.213.739 1.111.02.615-.359-1.319-.759z"
        fill="currentColor"
      />
      <path
        d="M17.943 46.958l-1.326-.759-.932.538v1.526l.932 1.615 1.326.76.931-.54v-1.524l-.931-1.616z"
        fill="currentColor"
      />
      <path
        d="M17.453 49.374l.09 2.968.704.663 1.236-.718V49.25l-2.03.124z"
        fill="currentColor"
      />
      <path
        d="M16.873 45.785l.753.235 1.857 3.23-1.236.711-2.533-3.224 1.16-.952z"
        fill="currentColor"
      />
      <path
        d="M14.989 44.501l-1.236.71.421 1.485 2.209.041 1.242-.718-2.636-1.518z"
        fill="currentColor"
      />
      <path
        d="M16.383 46.737l-2.63-1.525-1.863 1.077v3.044l1.863 3.223 2.63 1.519 1.864-1.07V49.96l-1.864-3.224zM25.909 39.849l-1.063-.58-.38.117v.58l1.077.628.366-.745z"
        fill="currentColor"
      />
      <path
        d="M27.303 40.373l-.242.221h-1.518v-.587l1.657-.234.103.6z"
        fill="currentColor"
      />
      <path
        d="M28.138 39.966v-.58l-.607-.152-.47.773v.587l1.077-.628z"
        fill="currentColor"
      />
      <path
        d="M27.061 40.007l1.077-.621v-.877l-1.077-.62h-1.518l-1.077.62v.877l1.077.621h1.518z"
        fill="currentColor"
      />
      <path
        d="M25.715 38.544l-.828.476-.007.007.007-.42.828-.477v.414zM26.888 38.13h-1.173v.414h1.173v-.414zM26.889 38.13l.828.476v.414l-.828-.476v-.414z"
        fill="currentColor"
      />
      <path
        d="M27.717 39.02v.27l-.828.476h-1.174l-.835-.477v-.262l.007-.007.828-.476h1.174l.828.476zM26.054 49.091l-.235.138-.373-1.021v-.187l.214.062 3.714-2.146-.594-.339v-.186h.318l.6.345 3.99-2.305 1.263.145.366-.035v.187l-.242.137-1.38-.172-7.931 4.583.29.794z"
        fill="currentColor"
      />
      <path
        d="M26.054 48.912l-.235.138-.373-1.029 3.928-2.264-.594-.345.235-.138.594.345 3.934-2.27 1.774.213-.242.138-1.38-.166-7.931 4.577.29.8zM32.653 47.297l-.138.276-1.72-.987v-.187l.118-.055 1.74.953zM32.777 47.428l.124.145 4.521-2.61v-.179h-.22l-4.5 2.513.075.13z"
        fill="currentColor"
      />
      <path
        d="M32.515 47.573l-.007-.18.22-.151.173.151v.18h-.386z"
        fill="currentColor"
      />
      <path
        d="M37.422 44.556v.228l-4.52 2.61h-.394l-1.712-.995v-.228l4.521-2.609h.394l1.711.994zM34.89 48.58l-.146.284-1.719-.994v-.18l.125-.062 1.74.953zM35.013 48.718l.125.145 4.52-2.609v-.18l-.227-.006-4.493 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M34.744 48.864v-.18l.214-.152.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M39.659 45.847v.228l-4.521 2.609h-.394l-1.719-.994v-.228l4.522-2.609h.393l1.719.994zM37.118 49.871l-.144.283-1.712-.994v-.18l.117-.061 1.74.952zM37.243 50.01l.124.144 4.521-2.609v-.186h-.22l-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M36.974 50.154v-.186l.22-.152.173.152v.186h-.393z"
        fill="currentColor"
      />
      <path
        d="M41.888 47.13v.229l-4.521 2.609h-.393l-1.712-.987v-.228l4.514-2.61h.393l1.72.988zM39.348 51.162l-.138.283-1.719-.994v-.18l.118-.062 1.739.953zM39.472 51.3l.132.145 4.52-2.616v-.18h-.227l-4.5 2.52.075.131z"
        fill="currentColor"
      />
      <path
        d="M39.21 51.445v-.186l.214-.152.18.152v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M44.125 48.422v.227l-4.522 2.61h-.393l-1.719-.987v-.228l4.521-2.61h.394l1.719.988zM41.584 52.453l-.145.276-1.718-.987v-.186l.124-.056 1.74.953zM41.709 52.584l.124.145 4.521-2.61v-.179l-.228-.007-4.493 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M41.44 52.729v-.18l.22-.151.173.152v.179h-.393z"
        fill="currentColor"
      />
      <path
        d="M46.354 49.712v.228l-4.521 2.61h-.394l-1.718-.994v-.228l4.52-2.61h.394l1.72.994zM27.683 50.168l-.145.276-1.719-.987v-.186l.125-.056 1.739.953zM27.807 50.299l.125.145 4.52-2.61v-.179l-.227-.007-4.5 2.52.082.131z"
        fill="currentColor"
      />
      <path
        d="M27.538 50.444v-.18l.214-.152.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M32.453 47.428v.227l-4.522 2.61h-.393l-1.719-.994v-.221l4.521-2.616h.394l1.719.994zM29.913 51.459l-.145.276-1.72-.994v-.18l.125-.062 1.74.96zM30.037 51.59l.124.145 4.521-2.61v-.179l-.22-.007-4.501 2.52.076.13z"
        fill="currentColor"
      />
      <path
        d="M29.768 51.735v-.18l.22-.152.173.152v.18h-.393z"
        fill="currentColor"
      />
      <path
        d="M34.682 48.718v.228l-4.521 2.61h-.393l-1.72-.995v-.227l4.522-2.61h.394l1.718.994zM32.142 52.743l-.138.283-1.719-.994v-.18l.124-.062 1.733.953zM32.266 52.88l.131.145 4.515-2.609v-.186h-.221l-4.494 2.52.07.13z"
        fill="currentColor"
      />
      <path
        d="M32.004 53.026v-.187l.214-.152.18.152v.187h-.394z"
        fill="currentColor"
      />
      <path
        d="M36.912 50.01v.22l-4.515 2.61h-.393l-1.719-.988v-.228l4.521-2.609h.394l1.712.994zM34.378 54.033l-.145.283-1.711-.994v-.186l.117-.055 1.74.952zM34.503 54.164l.124.152 4.521-2.609v-.186h-.228l-4.493 2.52.076.123z"
        fill="currentColor"
      />
      <path
        d="M34.233 54.316v-.186l.214-.152.18.152v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M39.148 51.293v.228l-4.521 2.609h-.394l-1.711-.994v-.22l4.514-2.61h.393l1.719.987zM36.608 55.324l-.138.276-1.719-.987v-.186l.117-.055 1.74.952zM36.732 55.455l.131.145 4.522-2.609-.007-.18-.221-.006-4.5 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M36.47 55.6v-.18l.214-.151.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M41.384 52.584l-.007.228-4.514 2.609h-.393l-1.719-.994v-.228l4.521-2.61h.394l1.718.995zM43.814 53.744l-.138.276-1.719-.994v-.18l.117-.062 1.74.96zM43.938 53.875l.131.145 4.515-2.61v-.186h-.221l-4.5 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M43.676 54.02v-.18l.214-.152.18.152v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M48.584 51.003v.221l-4.515 2.616h-.393l-1.719-.994v-.227l4.521-2.61h.394l1.712.994zM46.051 55.028l-.145.282-1.718-.994v-.179l.124-.062 1.74.953zM46.175 55.166l.125.144 4.521-2.609v-.186h-.228l-4.493 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M45.906 55.31v-.186l.214-.152.18.152v.186h-.394z"
        fill="currentColor"
      />
      <path
        d="M50.82 52.287v.228l-4.52 2.61h-.394l-1.718-.988v-.228l4.52-2.609h.394l1.719.987zM38.844 56.615l-.145.276-1.718-.994v-.18l.124-.061 1.74.959zM38.968 56.746l.125.145 4.521-2.61v-.179l-.228-.006-4.493 2.519.075.131z"
        fill="currentColor"
      />
      <path
        d="M38.7 56.89v-.179l.213-.151.18.151v.18h-.394z"
        fill="currentColor"
      />
      <path
        d="M43.614 53.875v.227l-4.521 2.61h-.394l-1.718-.994v-.228l4.52-2.61h.394l1.719.995zM41.074 57.899l-.139.283-1.718-.994v-.18l.117-.062 1.74.953zM41.198 58.037l.131.145 4.514-2.61v-.186h-.22l-4.5 2.52.075.13z"
        fill="currentColor"
      />
      <path
        d="M40.935 58.182v-.187l.215-.151.179.151v.187h-.394z"
        fill="currentColor"
      />
      <path
        d="M45.843 55.165v.221l-4.514 2.61h-.394l-1.718-.988v-.227l4.514-2.61h.393l1.72.994z"
        fill="currentColor"
      />
    </svg>
  )
}
